var path = 'components/menu-link.tpl.html';
var html = " <md-button ui-sref-active-eq=tb-active ui-sref={{section.state}}> <md-icon ng-show=\"section.icon != null\" aria-label={{section.icon}} class=material-icons>{{section.icon}}</md-icon> {{section.name | translate}} </md-button>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/menu-link.tpl.html
// module id = 1410
// module chunks = 1